var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eyeball-wrapper",style:(_vm.eyeballStyle)},[_c('div',{staticClass:"eyeball"},[_c('div',{staticClass:"iris-wrapper"},[_vm._t("default",[_c('div',{staticClass:"iris"})])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }